import { AxiosInstance } from 'axios';
import { JobBulkFinanceService } from './JobBulkFinanceService';

export class JobBulkService {
  instance: AxiosInstance;
  finance: JobBulkFinanceService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.finance = new JobBulkFinanceService(instance);
  }
}
